import React, { useState, useEffect, useRef } from 'react';
import {
  Modal,
  List,
  Card,
  Checkbox,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Button,
  Table,
  Typography,
  Popconfirm,
  notification,
  Divider,
  Radio,
  Select,
  Popover,
  TimePicker,
  Menu,
  Upload,
  message,
} from 'antd';
import { UploadOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import EmojiPicker from 'emoji-picker-react';
import "./menuList.scss";
import "../../styles/table-responsive.scss";
import axios from 'axios';

// Helper function to disable EndTime before StartTime - 修改为支持跨天时间段
const getDisabledEndTime = (startTime) => {
  if (!startTime) {
    return {};
  }

  // 不再限制endTime必须大于startTime，允许跨天的情况
  // 比如从23:00到02:00这种情况
  return {
    disabledHours: () => [],
    disabledMinutes: () => [],
    disabledSeconds: () => [],
  };
};

// EditableCell Component
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  form,
  ...restProps
}) => {
  const [emojiVisible, setEmojiVisible] = useState(false);
  const inputRef = useRef(null); // Ref for Input component

  // Generate preview content
  const generatePreviewContent = (text) => {
    return text.replace(/\$\{(.+?)\}/g, (match, emojiCode) => emojiCode);
  };

  const [, forceUpdate] = useState();
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    form.setFieldsValue({ [dataIndex]: newValue });
    forceUpdate({}); // Force update component
  };

  let inputNode = inputType === 'text' ? <Input /> : null;

  if (dataIndex === 'Price') {
    inputNode = <InputNumber style={{ width: '100%' }} />;
  } else if (dataIndex === 'Description1' || dataIndex === 'Description2') {
    inputNode = (
      <div>
        <Input
          ref={inputRef}
          value={form.getFieldValue(dataIndex)}
          onChange={handleInputChange}
          suffix={
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => setEmojiVisible(!emojiVisible)}
            >
              😀
            </span>
          }
        />
        {form.getFieldValue(dataIndex) &&
          form.getFieldValue(dataIndex).includes('$') && (
            <Popover
              content={generatePreviewContent(form.getFieldValue(dataIndex))}
              title="Preview"
              trigger="hover"
            >
              <Button size="small">Preview</Button>
            </Popover>
          )}
      </div>
    );
  }
  if (dataIndex === 'CategoryAvailableTimePeriod') {
    const CategoryStartTime = form.getFieldValue('CategoryStartTime');
    inputNode = (
      <div style={{ display: 'flex', gap: '8px' }}>
        <Form.Item name="CategoryStartTime" style={{ margin: 0, flex: 1 }}>
          <TimePicker
            placeholder="Start Time"
            format="HH:mm"
            onChange={() => {
              form.setFieldsValue({ CategoryEndTime: null });
            }}
          />
        </Form.Item>
        <Form.Item name="CategoryEndTime" style={{ margin: 0, flex: 1 }}>
          <TimePicker
            placeholder="End Time"
            format="HH:mm"
            disabled={!form.getFieldValue('CategoryStartTime')}
            disabledTime={() => getDisabledEndTime(form.getFieldValue('CategoryStartTime'))}
          />
        </Form.Item>
      </div>
    );
  } else if (dataIndex === 'CategoryEnable') {
    inputNode = <Checkbox />;
  } else if (dataIndex === 'CategoryPerPersonLimit') {
    inputNode = <InputNumber min={0} precision={0} style={{ width: '100%' }} />;
  }
  // } else if (dataIndex === 'MenuItemAvailableTimePeriod') {
  //   const MenuItemStartTime = form.getFieldValue('MenuItemStartTime');
  //   inputNode = (
  //     <div style={{ display: 'flex', gap: '8px' }}>
  //       <Form.Item name="MenuItemStartTime" style={{ margin: 0, flex: 1 }}>
  //         <TimePicker
  //           placeholder="Start Time"
  //           format="HH:mm"
  //           onChange={() => {
  //             form.setFieldsValue({ MenuItemEndTime: null });
  //           }}
  //         />
  //       </Form.Item>
  //       <Form.Item name="MenuItemEndTime" style={{ margin: 0, flex: 1 }}>
  //         <TimePicker
  //           placeholder="End Time"
  //           format="HH:mm"
  //           disabled={!form.getFieldValue('MenuItemStartTime')}
  //           disabledTime={() => getDisabledEndTime(form.getFieldValue('MenuItemStartTime'))}
  //         />
  //       </Form.Item>
  //     </div>
  //   );
  // }
  // } else if (dataIndex === 'SpecialTimePeriod') {
  //   const startTime = form.getFieldValue('StartTime');

  //   inputNode = (
  //     <div style={{ display: 'flex', gap: '8px' }}>
  //       <Form.Item name="StartTime" style={{ margin: 0, flex: 1 }}>
  //         <TimePicker
  //           placeholder="Start Time"
  //           format="HH:mm"
  //           onChange={() => {
  //             // Reset EndTime when StartTime changes
  //             form.setFieldsValue({ EndTime: null });
  //           }}
  //         />
  //       </Form.Item>
  //       <Form.Item name="EndTime" style={{ margin: 0, flex: 1 }}>
  //         <TimePicker
  //           placeholder="End Time"
  //           format="HH:mm"
  //           disabled={!form.getFieldValue('StartTime')}
  //           disabledTime={() => getDisabledEndTime(form.getFieldValue('StartTime'))}
  //         />
  //       </Form.Item>
  //     </div>
  //   );
  // }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          valuePropName={dataIndex === 'CategoryEnable' ? 'checked' : 'value'}
          rules={[
            ...(dataIndex === 'CategoryEnable' ? [] : [
              {
                required: true,
                message: `Please Input ${title}!`,
              }
            ]),
            ...(dataIndex === 'Price'
              ? [{ type: 'number', message: 'Please enter a valid number!' }]
              : []),
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// Main Component
const MenuListComponent = ({ title, data }) => {
  const [form] = Form.useForm();
  const [categoryData, setCategoryData] = useState([]);
  const [menuItemdata, setMenuItemData] = useState([]);
  const [subMenuItemdata, setSubMenuItemData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [originalRecord, setOriginalRecord] = useState(null);
  const [storeId, setStoreId] = useState('');
  const [showMultiLanguageOptions, setShowMultiLanguageOptions] = useState(false);

  const [editingData, setEditingData] = useState(null); // Currently editing data
  const [isModalVisible, setIsModalVisible] = useState(false); // Modal visibility
  
  // Image management states
  const [isImageModalVisible, setIsImageModalVisible] = useState(false); // Image modal visibility
  const [currentImageItem, setCurrentImageItem] = useState(null); // Current item for image editing
  const [itemImageFile, setItemImageFile] = useState(null); // Item image file for upload
  const [itemImagePreview, setItemImagePreview] = useState(null); // Item image preview URL
  const [isEditingImage, setIsEditingImage] = useState(false); // Whether in image editing mode
  const [imageExistsMap, setImageExistsMap] = useState({}); // Track which items have images
  const [imageTimestamps, setImageTimestamps] = useState({}); // Track image update timestamps for cache busting

  const [selectedItemDetails, setSelectedItemDetails] = useState([]); // Selected item details
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [matchedMainItems, setMatchedMainItems] = useState([]); // Matched main menu items

  const [updatedSubMenuItemData, setUpdatedSubMenuItemData] = useState([]); // Updated submenus

  const description1Ref = useRef(null);
  const description2Ref = useRef(null);

  const [emojiVisible1, setEmojiVisible1] = useState(false);
  const [emojiVisible2, setEmojiVisible2] = useState(false);

  // State for selected languages
  const [selectedLanguage, setSelectedLanguage] = useState({
    firstLanguage: '',
    secondLanguage: '',
  });
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [menuSearchInput, setMenuSearchInput] = useState('');
  const [menuSearchText, setMenuSearchText] = useState('');

  // Handle category change
  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const handleMenuSearch = () => {
    setMenuSearchText(menuSearchInput.trim().toLowerCase());
  };

  // Filtered menu items based on selected category
  const filteredMenuItems = menuItemdata.filter((item) => {
    const categoryMatched =
      selectedCategory === 'All' || item.CategoryCode === selectedCategory;
    if (!categoryMatched) {
      return false;
    }
    if (!menuSearchText) {
      return true;
    }
    return [item.ItemCode, item.Description1, item.Description2]
      .some((value) => String(value || '').toLowerCase().includes(menuSearchText));
  });

  // Handle language change
  const handleLanguageChange = (value, type) => {
    setSelectedLanguage((prev) => ({ ...prev, [type]: value }));
  };

  // Handle save languages
  const handleSaveLanguages = async () => {
    try {
      const token = sessionStorage.getItem('jwtToken'); // Get JWT Token
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/change-language`,
        {
          MultiLanguage: showMultiLanguageOptions,
          firstLanguage: selectedLanguage.firstLanguage || null,
          secondLanguage: selectedLanguage.secondLanguage || null,
          storeId: storeId,
        },
        config
      );

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Language has been updated',
        });
      } else {
        notification.error({
          message: 'Error',
          description: 'Failed to update the language',
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
      notification.error({
        message: 'Error',
        description: 'Failed to update the language',
      });
    }
  };

  const languages = [
    { name: 'English', code: 'en' },
    { name: '简体中文', code: 'zh' },
    { name: '繁體中文', code: 'zf' },
    { name: '한국어', code: 'ko' },
    { name: '日本語', code: 'ja' },
    { name: 'Tiếng Việt', code: 'vi' },
    { name: 'ไทย', code: 'th' },
  ];

  // Insert emoji at cursor position
  const insertAtCursor = (input, emoji) => {
    const inputRef = input.input;

    const startPos = inputRef.selectionStart;
    const endPos = inputRef.selectionEnd;
    const textBefore = inputRef.value.substring(0, startPos);
    const textAfter = inputRef.value.substring(endPos, inputRef.value.length);
    return textBefore + emoji + textAfter;
  };

  // Handle emoji click
  const handleEmojiClick = (event, emojiObject, inputRef, fieldName) => {
    const input = inputRef.current;

    const newValue = insertAtCursor(input, event.emoji);
    setEditingData({ ...editingData, [fieldName]: newValue });

    // Reset cursor position
    setTimeout(() => {
      input.focus();
      const cursorPosition = input.selectionStart + event.emoji.length; // New cursor position
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);

    setEmojiVisible1(false);
    setEmojiVisible2(false);
  };

  // Handle edit button click
  const handleEditClick = (record) => {
    const details = findSubMenuDetails(record.ItemCode);
    setSelectedItemDetails(details); // Set selected item details
    setEditingData(record); // Set current editing data
    setIsModalVisible(true); // Show modal
  };

  // Handle image click - open image management modal
  const handleImageClick = (record) => {
    setCurrentImageItem(record);
    const hasImage = imageExistsMap[record.ItemCode];
    
    if (hasImage) {
      const timestamp = imageTimestamps[record.ItemCode] || 0;
      setItemImagePreview(`${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${record.ItemCode}?t=${timestamp}`);
      setIsEditingImage(false);
    } else {
      setItemImagePreview(null);
      setIsEditingImage(true);
    }
    
    setItemImageFile(null);
    setIsImageModalVisible(true);
  };

  // Handle image modal close
  const handleImageModalClose = () => {
    setIsImageModalVisible(false);
    setCurrentImageItem(null);
    setItemImageFile(null);
    setItemImagePreview(null);
    setIsEditingImage(false);
  };

  // Handle start editing image
  const handleStartEditImage = () => {
    setIsEditingImage(true);
  };

  // Handle cancel editing image
  const handleCancelEditImage = () => {
    setIsEditingImage(false);
    setItemImageFile(null);
    if (currentImageItem) {
      const timestamp = imageTimestamps[currentImageItem.ItemCode] || 0;
      setItemImagePreview(`${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${currentImageItem.ItemCode}?t=${timestamp}`);
    }
  };

  // Compress image to under 200KB
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          
          // Calculate new dimensions to maintain aspect ratio
          const maxSize = 1024; // Max width or height
          if (width > height && width > maxSize) {
            height = (height * maxSize) / width;
            width = maxSize;
          } else if (height > maxSize) {
            width = (width * maxSize) / height;
            height = maxSize;
          }
          
          canvas.width = width;
          canvas.height = height;
          
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          // Start with quality 0.9 and reduce if needed
          let quality = 0.9;
          const compress = () => {
            canvas.toBlob(
              (blob) => {
                if (blob.size > 200 * 1024 && quality > 0.1) {
                  quality -= 0.1;
                  compress();
                } else {
                  resolve(new File([blob], file.name, { type: 'image/jpeg' }));
                }
              },
              'image/jpeg',
              quality
            );
          };
          compress();
        };
        img.onerror = reject;
      };
      reader.onerror = reject;
    });
  };

  // Handle image upload
  const handleImageUpload = async (file) => {
    try {
      // Check file type
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('You can only upload image files!');
        return false;
      }

      // Check file size (max 10MB before compression)
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error('Image must be smaller than 10MB!');
        return false;
      }

      message.loading({ content: 'Compressing image...', key: 'compress' });
      
      // Compress image
      const compressedFile = await compressImage(file);
      
      message.success({ content: `Image compressed to ${(compressedFile.size / 1024).toFixed(2)}KB`, key: 'compress', duration: 2 });
      
      setItemImageFile(compressedFile);
      
      // Create preview URL
      const previewUrl = URL.createObjectURL(compressedFile);
      setItemImagePreview(previewUrl);
      
      return false; // Prevent auto upload
    } catch (error) {
      message.error('Failed to process image');
      console.error('Image compression error:', error);
      return false;
    }
  };

  // Handle delete image from server
  const handleDeleteImageFromServer = async () => {
    if (!currentImageItem) return;

    try {
      const token = sessionStorage.getItem('jwtToken');
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/delete-menu-item-image`,
        {
          itemCode: currentImageItem.ItemCode,
          storeId: storeId,
        },
        config
      );

      if (response.status === 200) {
        message.success('Image deleted successfully');
        const newTimestamp = Date.now();
        setImageExistsMap(prev => ({ ...prev, [currentImageItem.ItemCode]: false }));
        setImageTimestamps(prev => ({ ...prev, [currentImageItem.ItemCode]: newTimestamp }));
        setItemImagePreview(null);
        handleImageModalClose();
        fethcMenuList();
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      if (error.response?.status === 404) {
        message.error('Image not found');
      } else {
        message.error('Failed to delete image');
      }
    }
  };

  // Handle save image
  const handleSaveImage = async () => {
    if (!itemImageFile || !currentImageItem) {
      message.warning('Please select an image first');
      return;
    }

    try {
      message.loading({ content: 'Uploading image...', key: 'upload' });

      // Convert file to base64
      const reader = new FileReader();
      reader.readAsDataURL(itemImageFile);
      
      const base64Image = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });

      const token = sessionStorage.getItem('jwtToken');
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/upload-menu-item-image`,
        {
          image: base64Image,
          itemCode: currentImageItem.ItemCode,
          storeId: storeId,
        },
        config
      );

      if (response.status === 200) {
        message.success({ content: 'Image uploaded successfully', key: 'upload' });
        const newTimestamp = Date.now();
        setImageExistsMap(prev => ({ ...prev, [currentImageItem.ItemCode]: true }));
        setImageTimestamps(prev => ({ ...prev, [currentImageItem.ItemCode]: newTimestamp }));
        handleImageModalClose();
        fethcMenuList();
      } else {
        message.error({ content: 'Failed to upload image', key: 'upload' });
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      message.error({ content: 'Failed to upload image', key: 'upload' });
    }
  };

  // Find sub-menu details
  const findSubMenuDetails = (itemCode) => {
    // Find all submenus
    const matchedSubMenus = subMenuItemdata.filter(
      (item) => item.MainItemCode === itemCode
    );

    // For each submenu, find corresponding child submenus
    return matchedSubMenus.map((subMenu) => {
      // Use SubMenuCode to find child submenus
      const childSubMenus = subMenuItemdata.filter(
        (item) => item.MainItemCode === subMenu.SubMenuCode
      );

      return {
        ...subMenu,
        childSubMenus: childSubMenus, // Add child submenus to the object
      };
    });
  };

  // Update submenu data
  const updateSubMenuData = (index, field, value) => {
    const updatedItems = [...selectedItemDetails];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    setSelectedItemDetails(updatedItems);
  };

  // Update child submenu data
  const updateChildSubMenuData = (parentIndex, childIndex, field, value) => {
    const updatedItems = [...selectedItemDetails];
    const updatedChildSubMenus = [...updatedItems[parentIndex].childSubMenus];
    updatedChildSubMenus[childIndex] = {
      ...updatedChildSubMenus[childIndex],
      [field]: value,
    };
    updatedItems[parentIndex].childSubMenus = updatedChildSubMenus;
    setSelectedItemDetails(updatedItems);
  };

  // Handle pre-save menu
  const handleMenuSavePre = async () => {
    try {
      const flattenSelectedItems = selectedItemDetails.reduce((acc, cur) => {
        acc.push(cur);
        acc.push(...cur.childSubMenus);
        return acc;
      }, []);

      // Find updated items by comparing with existing subMenuItemdata
      const updatedSubMenuItemData = flattenSelectedItems.filter((item) => {
        const matchedItem = subMenuItemdata.find(
          (subItem) => subItem.SubMenuCode === item.SubMenuCode
        );
        return (
          !matchedItem ||
          matchedItem.Description1 !== item.Description1 ||
          matchedItem.Description2 !== item.Description2 ||
          matchedItem.SalesPrice !== item.SalesPrice ||
          matchedItem.NumberOfChoice !== item.NumberOfChoice

        );
      });

      // Check if editing data has been modified
      const isDataModified = menuItemdata.some(
        (item) =>
          item.ItemCode === editingData.ItemCode &&
          (item.Description1 !== editingData.Description1 ||
            item.Description2 !== editingData.Description2 ||
            item.TagDescription !== editingData.TagDescription ||
            item.TagDescription1 !== editingData.TagDescription1 ||
            item.Price !== editingData.Price ||
            item.SubDescription !== editingData.SubDescription ||
            item.Multiple !== editingData.Multiple ||
            item.Price1 !== editingData.Price1 ||
            item.SubDescription1 !== editingData.SubDescription1 ||
            item.Price2 !== editingData.Price2 ||
            item.SubDescription2 !== editingData.SubDescription2 ||
            item.Price3 !== editingData.Price3 ||
            item.SoldOut !== editingData.SoldOut ||
            item.Enable !== editingData.Enable ||
            item.SpellInstruction !== editingData.SpellInstruction ||
            item.MenuItemStartTime !== editingData.MenuItemStartTime ||
            item.MenuItemEndTime !== editingData.MenuItemEndTime ||
            (Number(item.OrderCooldownSeconds) || 0) !== (Number(editingData.OrderCooldownSeconds) || 0) ||
            (Number(item.PerPersonLimit) || 0) !== (Number(editingData.PerPersonLimit) || 0)
          )
      );

      if (updatedSubMenuItemData.length === 0 && !isDataModified) {
        setIsModalVisible(false);
        return;
      }
      setUpdatedSubMenuItemData(updatedSubMenuItemData);

      if (
        selectedItemDetails.length > 0 &&
        updatedSubMenuItemData.length > 0
      ) {
        // Flatten selectedItemDetails to include both parent and child submenus

        // Initialize an array to store related main item descriptions
        let relatedMainItemDescriptions = [];

        // Process each updated item
        for (const item of updatedSubMenuItemData) {
          let parentSubMenuCode = item.MainItemCode;

          // If the item is a child submenu, find its parent submenu
          if (item.SubCategory === 1) {
            const parentSubMenu = subMenuItemdata.find(
              (subItem) =>
                subItem.SubMenuCode === item.MainItemCode &&
                subItem.SubCategory === 0
            );
            parentSubMenuCode = parentSubMenu
              ? parentSubMenu.MainItemCode
              : null;
          }

          // Find related submenus, excluding the item itself
          const relatedSubmenu = subMenuItemdata.filter(
            (subItem) =>
              subItem.MainItemCode === parentSubMenuCode &&
              subItem.SubMenuCode !== item.SubMenuCode
          );

          // Get descriptions of related main menu items
          const descriptions = relatedSubmenu
            .map((subItem) => {
              const matchedMenuItem = menuItemdata.find(
                (mainItem) => mainItem.ItemCode === subItem.MainItemCode
              );
              return matchedMenuItem ? matchedMenuItem.Description1 : null;
            })
            .filter((desc) => desc != null);

          // Add these descriptions to the array
          relatedMainItemDescriptions = [
            ...relatedMainItemDescriptions,
            ...descriptions,
          ];
        }

        // Remove duplicates and update matchedMainItems state
        relatedMainItemDescriptions = [
          ...new Set(relatedMainItemDescriptions),
        ];
        setMatchedMainItems(relatedMainItemDescriptions);

        setIsConfirmModalVisible(true);
      } else if (updatedSubMenuItemData.length === 0 && isDataModified) {
        handleMenuSave();
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
      notification.error({
        message: 'Error',
        description: 'Failed to update the menu item',
      });
    }
  };

  // Handle menu save
  const handleMenuSave = async () => {
    try {
      const token = sessionStorage.getItem('jwtToken'); // Get JWT Token
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      if (editingData?.SoldOut) {
        // Set SoldOut to 1
        editingData.SoldOut = 1;
      } else {
        editingData.SoldOut = 0;
      }
      if (editingData?.Enable) {
        // Set Enable to 1
        editingData.Enable = 1;
      } else {
        editingData.Enable = 0;
      }
      if (editingData?.SpellInstruction) {
        // Set SpellInstruction to 1
        editingData.SpellInstruction = 1;
      } else {
        editingData.SpellInstruction = 0;
      }
      let copiedEditingData = { 
        ...editingData, 
        OrderCooldownSeconds: Math.max(0, parseInt(editingData.OrderCooldownSeconds, 10) || 0),
        PerPersonLimit: Math.max(0, parseInt(editingData.PerPersonLimit, 10) || 0),
        MenuItemStartTime: editingData.MenuItemStartTime ? editingData.MenuItemStartTime.format('HH:mm:ss') : null, 
        MenuItemEndTime: editingData.MenuItemEndTime ? editingData.MenuItemEndTime.format('HH:mm') : null 
      };

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/change-menu-item`,
        { copiedEditingData, updatedSubMenuItemData },
        config
      );

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Menu item has been updated',
        });

        setIsConfirmModalVisible(false); // Close confirm modal
        setIsModalVisible(false); // Close edit modal
        setEditingKey(''); // Reset editing key
        setUpdatedSubMenuItemData([]); // Reset updated submenus
        
        // Re-fetch menu list
        fethcMenuList();
      } else {
        notification.error({
          message: 'Error',
          description: 'Failed to update the menu item',
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
      notification.error({
        message: 'Error',
        description: 'Failed to update the menu item',
      });
    }
  };

  // Confirm modal handlers
  const handleConfirmModalOk = () => {
    handleMenuSave(); // Execute save
  };
  const handleConfirmModalCancel = () => {
    setIsConfirmModalVisible(false); // Close confirm modal without saving
  };

  // Cancel edit modal
  const handleCancel = () => {
    setIsModalVisible(false);
    setItemImageFile(null);
    setItemImagePreview(null);
  };

  // Toggle multi-language options
  const toggleMultiLanguage = () => {
    setShowMultiLanguageOptions(!showMultiLanguageOptions);
  };

  // Fetch menu list from server
  const fethcMenuList = async () => {
    try {
      const token = sessionStorage.getItem('jwtToken'); // Get JWT Token
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/fetchMenuList`,
        config
      );
      

      setCategoryData(
        response.data.categoryResult.map((item) => ({
          ...item,
          CategoryStartTime: item.StartTime ? dayjs(item.StartTime, 'HH:mm:ss') : null,
          CategoryEndTime: item.EndTime ? dayjs(item.EndTime, 'HH:mm:ss') : null,
          CategoryPerPersonLimit: Number(item.CategoryPerPersonLimit) || 0,
        }))
      );

      setMenuItemData(response.data.menuItemsResult.map((item) => ({
        ...item,
        OrderCooldownSeconds: Number(item.OrderCooldownSeconds) || 0,
        PerPersonLimit: Number(item.PerPersonLimit) || 0,
        CategoryPerPersonLimit: Number(item.CategoryPerPersonLimit) || 0,
        MenuItemStartTime: item.MenuItemStartTime ? dayjs(item.MenuItemStartTime, 'HH:mm:ss') : null,
        MenuItemEndTime: item.MenuItemEndTime ? dayjs(item.MenuItemEndTime, 'HH:mm:ss') : null,
      }))
      );
      
      setSubMenuItemData(response.data.subMenuLinksResult);
      if (response.data.storeMultipleLanguageResult.MultiLanguage) {
        setShowMultiLanguageOptions(true); // Show multi-language options

        setSelectedLanguage({
          firstLanguage:
            response.data.storeMultipleLanguageResult.FirstLanguage,
          secondLanguage:
            response.data.storeMultipleLanguageResult.SecondLanguage,
        });
      }
    } catch (error) {
      console.log('Failed to fetch menu list:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to fetch menu list',
      });
    }
  };


  useEffect(() => {
    setStoreId(data[3]);
    fethcMenuList();
  }, [data]);

  // Check image existence for all menu items on initial load
  useEffect(() => {
    if (menuItemdata.length > 0 && storeId) {
      const checkImages = async () => {
        const imageChecks = {};
        
        for (const item of menuItemdata) {
          // Skip if we already know the status
          if (imageExistsMap[item.ItemCode] !== undefined) {
            continue;
          }
          
          try {
            const response = await fetch(
              `${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${item.ItemCode}`,
              { method: 'HEAD' }
            );
            imageChecks[item.ItemCode] = response.ok;
          } catch {
            imageChecks[item.ItemCode] = false;
          }
        }
        
        if (Object.keys(imageChecks).length > 0) {
          setImageExistsMap(prev => ({ ...prev, ...imageChecks }));
        }
      };
      
      checkImages();
    }
  }, [menuItemdata, storeId]);

  const isEditing = (record) => record.CategoryCode === editingKey;

  const edit = (record) => {
    form.setFieldsValue({ 
      ...record,
      CategoryEnable: record.CategoryEnable === 1
    });
    setEditingKey(record.CategoryCode);
    setOriginalRecord({ ...record });
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const currentCategory = form.getFieldValue('Category');
      const currentCategory1 = form.getFieldValue('Category1');
      const currentEnable = form.getFieldValue('CategoryEnable');
      const currentCategoryPerPersonLimit = Math.max(0, parseInt(form.getFieldValue('CategoryPerPersonLimit'), 10) || 0);

      const startTime = form.getFieldValue('CategoryStartTime')
        ? form.getFieldValue('CategoryStartTime').format('HH:mm')
        : null; // Convert dayjs to string

      const endTime = form.getFieldValue('CategoryEndTime')
        ? form.getFieldValue('CategoryEndTime').format('HH:mm')
        : null; // Convert dayjs to string

      // Check if any field has changed
      if (
        originalRecord &&
        currentCategory === originalRecord.Category &&
        currentCategory1 === originalRecord.Category1 &&
        startTime === originalRecord.CategoryStartTime &&
        endTime === originalRecord.CategoryEndTime &&
        (currentEnable ? 1 : 0) === originalRecord.CategoryEnable &&
        currentCategoryPerPersonLimit === (Number(originalRecord.CategoryPerPersonLimit) || 0)
      ) {
        setEditingKey('');
        return; // No changes, return
      }

      if (startTime !==null && endTime ===null) {
        return notification.error({
          message: 'Error',
          description: 'Please select both start and end time',
        });
      }


      const token = sessionStorage.getItem('jwtToken'); // Get JWT Token
      const config = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      // Send update request
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/change-category`,
        {
          categoryCode: key,
          category: currentCategory,
          category1: currentCategory1,
          startTime: startTime,
          endTime: endTime,
          categoryEnable: currentEnable ? 1 : 0,
          categoryPerPersonLimit: currentCategoryPerPersonLimit,
          storeId: storeId,
        },
        config
      );

      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Category has been updated',
        });
      
        // Re-fetch menu list
        fethcMenuList();
      } else {
        notification.error({
          message: 'Error',
          description: 'Failed to update the category',
        });
      }

      setEditingKey('');
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
      notification.error({
        message: 'Error',
        description: 'Failed to update the category',
      });
    }
  };

  // New state for tracking menu editing
  const [editingMenuKey, setEditingMenuKey] = useState('');

  // Handle menu editing
  const isMenuEditing = (record) => record.ItemCode === editingMenuKey;

  const editMenu = (record) => {
    form.setFieldsValue({ ...record });
    setEditingMenuKey(record.ItemCode);
  };

  const cancelMenuEdit = () => {
    setEditingMenuKey('');
  };



  // Define category table columns
  const categoryColumns = [
    { title: 'Category Code', dataIndex: 'CategoryCode', key: 'CategoryCode' },
    {
      title: 'Description 1',
      dataIndex: 'Category',
      key: 'Category',
      editable: true,
    },
    {
      title: 'Description 2',
      dataIndex: 'Category1',
      key: 'Category1',
      editable: true,
    },
    {
      title: 'Available Time Period',
      dataIndex: 'CategoryAvailableTimePeriod',
      key: 'CategoryAvailableTimePeriod',
      editable: true,
      render: (text, record) => {
        const startTime = record.CategoryStartTime
          ? dayjs(record.CategoryStartTime).format('HH:mm')
          : '-';
        const endTime = record.CategoryEndTime
          ? dayjs(record.CategoryEndTime).format('HH:mm')
          : '-';
        return `${startTime} - ${endTime}`;
      },
    },
    {
      title: 'Enable',
      dataIndex: 'CategoryEnable',
      key: 'CategoryEnable',
      editable: true,
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Form.Item
            name="CategoryEnable"
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox />
          </Form.Item>
        ) : (
          <Checkbox checked={record.CategoryEnable === 1} disabled />
        );
      },
    },
    {
      title: 'Per Person Limit',
      dataIndex: 'CategoryPerPersonLimit',
      key: 'CategoryPerPersonLimit',
      editable: true,
      render: (text) => Number(text) || 0,
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Popconfirm
              title="Are you sure to save?"
              onConfirm={() => save(record.CategoryCode)}
            >
              <a style={{ color: '#1677ff' }}>Save</a>
            </Popconfirm>
            <Typography.Link
              onClick={() => cancel()}
              style={{ color: 'black', marginLeft: 8 }}
            >
              Cancel
            </Typography.Link>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ''}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      },
    },
  ];

  // Merge category columns with EditableCell
  const mergedColumns = categoryColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'CategoryCode' ? 'text' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
        form, // Pass the form prop here
      }),
    };
  });

  // Define menu table columns
  const menuColumns = [
    { title: 'Item Code', dataIndex: 'ItemCode', key: 'ItemCode' },
    {
      title: 'Item Image',
      dataIndex: 'ItemImage',
      key: 'ItemImage',
      render: (_, record) => {
        const hasImage = imageExistsMap[record.ItemCode];
        
        if (hasImage === false) {
          return (
            <div
              onClick={() => handleImageClick(record)}
              style={{ 
                width: '60px', 
                height: '60px', 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                border: '2px dashed #d9d9d9',
                borderRadius: '4px',
                cursor: 'pointer',
                backgroundColor: '#fafafa',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#1890ff';
                e.currentTarget.style.backgroundColor = '#e6f7ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#d9d9d9';
                e.currentTarget.style.backgroundColor = '#fafafa';
              }}
              title="Click to add image"
            >
              <PlusOutlined style={{ fontSize: '20px', color: '#999' }} />
              <span style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>Add</span>
            </div>
          );
        }
        
        const timestamp = imageTimestamps[record.ItemCode] || 0;
        return (
          <img
            crossOrigin="anonymous"
            width={60}
            height={60}
            src={`${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${record.ItemCode}?t=${timestamp}`}
            onLoad={() => {
              // Only update if status is unknown
              if (imageExistsMap[record.ItemCode] === undefined) {
                setImageExistsMap(prev => ({ ...prev, [record.ItemCode]: true }));
              }
            }}
            onError={(e) => { 
              e.target.onerror = null;
              // Only update if status is unknown
              if (imageExistsMap[record.ItemCode] === undefined) {
                setImageExistsMap(prev => ({ ...prev, [record.ItemCode]: false }));
              }
            }}
            onClick={() => handleImageClick(record)}
            style={{ objectFit: 'cover', borderRadius: '4px', cursor: 'pointer', border: '1px solid #d9d9d9' }}
            alt={record.Description1 || 'Menu Item'}
            title="Click to manage image"
          />
        );
      },
    },
    {
      title: 'Description 1',
      dataIndex: 'Description1',
      key: 'Description1',
      editable: true,
    },
    {
      title: 'Description 2',
      dataIndex: 'Description2',
      key: 'Description2',
      editable: true,
    },
    {
      title: 'Main Price',
      dataIndex: 'Price',
      key: 'Price',
      editable: true,
    },
    {
      title: 'Available Time Period',
      dataIndex: 'MenuItemAvailableTimePeriod',
      key: 'MenuItemAvailableTimePeriod',
      editable: true,
      render: (text, record) => {
       
        const startTime = record.MenuItemStartTime
          ? dayjs(record.MenuItemStartTime).format('HH:mm')
          : '-';
   
        const endTime = record.MenuItemEndTime
          ? dayjs(record.MenuItemEndTime).format('HH:mm')
          : '-';
        return `${startTime} - ${endTime}`;
      },
    },
    {
      title: 'Cooldown (s)',
      dataIndex: 'OrderCooldownSeconds',
      key: 'OrderCooldownSeconds',
      render: (text) => Number(text) || 0,
    },
    {
      title: 'Per Person Limit',
      dataIndex: 'PerPersonLimit',
      key: 'PerPersonLimit',
      render: (text) => Number(text) || 0,
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (_, record) => (
        <Typography.Link onClick={() => handleEditClick(record)}>
          Edit
        </Typography.Link>
      ),
    },
  ];

  // Merge menu columns with EditableCell
  const mergedMenuColumns = menuColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'Price' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isMenuEditing(record),
        form, // Pass the form prop here
      }),
    };
  });

  // Card styles
  const cardStyle = {
    border: '1px solid #d9d9d9',
    borderRadius: '4px',
    overflow: 'hidden',
  };

  const cardHeaderStyle = {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #d9d9d9',
    padding: '8px 16px',
    position: 'relative',
    top: '-1px',
    left: '-1px',
  };

  return (
    <Form form={form} component={false}>
      <div>
        {/* Category Table */}
        <Table
          components={{
            body: {
              cell: (props) => <EditableCell {...props} form={form} />, // Pass form prop here
            },
          }}
          bordered
          dataSource={categoryData}
          columns={mergedColumns}
          rowClassName="editable-row"
          rowKey="CategoryCode"
        />

        <Divider />

        {/* Multi-Language Options */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            marginLeft: '15px',
          }}
        >
          <Radio
            onClick={toggleMultiLanguage}
            checked={showMultiLanguageOptions}
            style={{ marginBottom: '5px' }}
          >
            Multiple Languages
          </Radio>
          {showMultiLanguageOptions && (
            <>
              <Select
                style={{ width: 200, marginRight: '10px' }}
                placeholder="First Language"
                value={selectedLanguage.firstLanguage}
                onChange={(value) =>
                  handleLanguageChange(value, 'firstLanguage')
                }
              >
                {languages.map((lang) => (
                  <Select.Option key={lang.code} value={lang.code}>
                    {lang.name}
                  </Select.Option>
                ))}
              </Select>
              <Select
                style={{ width: 200, marginRight: '10px' }}
                placeholder="Second Language"
                value={selectedLanguage.secondLanguage}
                onChange={(value) =>
                  handleLanguageChange(value, 'secondLanguage')
                }
              >
                {languages.map((lang) => (
                  <Select.Option key={lang.code} value={lang.code}>
                    {lang.name}
                  </Select.Option>
                ))}
              </Select>
            </>
          )}
          <Button type="primary" onClick={handleSaveLanguages}>
            Save
          </Button>
        </div>

        {/* Menu item filters */}
        <Row gutter={[12, 12]} style={{ marginBottom: 20, marginTop: 20, marginLeft: 0, marginRight: 0 }}>
          <Col xs={24} sm={8} md={5}>
            <Select
              style={{ width: '100%' }}
              placeholder="Select a category"
              onChange={handleCategoryChange}
              value={selectedCategory}
            >
              <Select.Option key="All" value="All">
                ** All **
              </Select.Option>
              {categoryData.map((category) => (
                <Select.Option
                  key={category.CategoryCode}
                  value={category.CategoryCode}
                >
                  {category.Category}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={10} md={8}>
            <Input
              allowClear
              placeholder="Search item code, Description 1 or Description 2"
              value={menuSearchInput}
              onChange={(e) => {
                setMenuSearchInput(e.target.value);
                if (!e.target.value) {
                  setMenuSearchText('');
                }
              }}
              onPressEnter={handleMenuSearch}
            />
          </Col>
          <Col xs={24} sm={6} md={4}>
            <Button type="primary" onClick={handleMenuSearch}>
              Search
            </Button>
          </Col>
        </Row>

        {/* Menu Items Table */}
        <Table
          components={{
            body: {
              cell: (props) => <EditableCell {...props} form={form} />, // Pass form prop here
            },
          }}
          bordered
          dataSource={filteredMenuItems}
          columns={mergedMenuColumns}
          rowClassName="editable-row"
          rowKey="ItemCode"
          pagination={{
            pageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            showTotal: (total) => `${total} items`,
          }}
        />
      </div>

      {/* Edit Menu Item Modal */}
      <Modal
        title="Edit Menu Item"
        open={isModalVisible}
        onOk={handleMenuSavePre}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleMenuSavePre}>
            OK
          </Button>,
        ]}
      >
        <div
          className="no-scrollbar"
          style={{ maxHeight: '60vh', overflowY: 'auto' }}
        >
          {/* Modal Form */}
          <Form layout="vertical">
            <Form.Item label="Description 1">
              <Input
                ref={description1Ref}
                value={editingData?.Description1}
                onChange={(e) =>
                  setEditingData({
                    ...editingData,
                    Description1: e.target.value,
                  })
                }
                suffix={
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => setEmojiVisible1(true)}
                  >
                    😀
                  </span>
                }
              />
              <Popover
                content={
                  <EmojiPicker
                    onEmojiClick={(event, emojiObject) =>
                      handleEmojiClick(
                        event,
                        emojiObject,
                        description1Ref,
                        'Description1'
                      )
                    }
                  />
                }
                trigger="click"
                open={emojiVisible1}
                onOpenChange={setEmojiVisible1}
              />
            </Form.Item>
            <Form.Item label="Description 2">
              <Input
                ref={description2Ref}
                value={editingData?.Description2}
                onChange={(e) =>
                  setEditingData({
                    ...editingData,
                    Description2: e.target.value,
                  })
                }
                suffix={
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => setEmojiVisible2(true)}
                  >
                    😀
                  </span>
                }
              />
              <Popover
                content={
                  <EmojiPicker
                    onEmojiClick={(event, emojiObject) =>
                      handleEmojiClick(
                        event,
                        emojiObject,
                        description2Ref,
                        'Description2'
                      )
                    }
                  />
                }
                trigger="click"
                open={emojiVisible2}
                onOpenChange={setEmojiVisible2}
              />
            </Form.Item>
            <Form.Item label="Tag Description 1">
              <Input
                value={editingData?.TagDescription}
                onChange={(e) =>
                  setEditingData({
                    ...editingData,
                    TagDescription: e.target.value,
                  })
                }
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item label="Tag Description 2">
              <Input
                value={editingData?.TagDescription1}
                onChange={(e) =>
                  setEditingData({
                    ...editingData,
                    TagDescription1: e.target.value,
                  })
                }
                style={{ width: '100%' }}
              />
            </Form.Item>

            <Card>
              <Row gutter={16} className="custom-row">
                <Col span={12}>
                  <Form.Item label="Price 1">
                    <InputNumber
                      value={editingData?.Price}
                      style={{ width: '100%' }}
                      onChange={(value) =>
                        setEditingData({ ...editingData, Price: value })
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Sub Description 1">
                    <Input
                      value={editingData?.SubDescription}
                      style={{ width: '100%' }}
                      onChange={(e) =>
                        setEditingData({
                          ...editingData,
                          SubDescription: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              {editingData?.Multiple ? (
                <>
                  <Row gutter={16} className="custom-row">
                    <Col span={12}>
                      <Form.Item label="Price 2">
                        <InputNumber
                          value={editingData?.Price1}
                          style={{ width: '100%' }}
                          onChange={(value) =>
                            setEditingData({
                              ...editingData,
                              Price1: value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Sub Description 2">
                        <Input
                          value={editingData?.SubDescription1}
                          style={{ width: '100%' }}
                          onChange={(e) =>
                            setEditingData({
                              ...editingData,
                              SubDescription1: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16} className="custom-row">
                    <Col span={12}>
                      <Form.Item label="Price 3">
                        <InputNumber
                          value={editingData?.Price2}
                          style={{ width: '100%' }}
                          onChange={(value) =>
                            setEditingData({
                              ...editingData,
                              Price2: value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Sub Description 3">
                        <Input
                          value={editingData?.SubDescription2}
                          style={{ width: '100%' }}
                          onChange={(e) =>
                            setEditingData({
                              ...editingData,
                              SubDescription2: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16} className="custom-row">
                    <Col span={12}>
                      <Form.Item label="Price 4">
                        <InputNumber
                          value={editingData?.Price3}
                          style={{ width: '100%' }}
                          onChange={(value) =>
                            setEditingData({
                              ...editingData,
                              Price3: value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Sub Description 4">
                        <Input
                          value={editingData?.SubDescription3}
                          style={{ width: '100%' }}
                          onChange={(e) =>
                            setEditingData({
                              ...editingData,
                              SubDescription3: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Card>

            <Row gutter={16} className="custom-row" style={{ marginTop: 8 }}>
              <Col span={12}>
                <Form.Item>
                  <Checkbox
                    checked={editingData?.Multiple}
                    onChange={(e) =>
                      setEditingData({
                        ...editingData,
                        Multiple: e.target.checked,
                      })
                    }
                  >
                    Multiple Price
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={12}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: 8 }}>GST(%)</div>
                  <InputNumber
                    value={editingData?.TaxRate}
                    style={{ width: '57px' }}
                    onChange={(value) =>
                      setEditingData({ ...editingData, TaxRate: value })
                    }
                  />
                </div>
              </Col>
            </Row>
            <Row gutter={16} className="custom-row">
              <Col span={12}>
                <Form.Item>
                  <Checkbox
                    checked={editingData?.Enable}
                    onChange={(e) =>
                      setEditingData({
                        ...editingData,
                        Enable: e.target.checked,
                      })
                    }
                  >
                    Enable
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item>
                  <Checkbox
                    checked={editingData?.SoldOut}
                    onChange={(e) =>
                      setEditingData({
                        ...editingData,
                        SoldOut: e.target.checked,
                      })
                    }
                  >
                    Sold Out
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} className="custom-row">
              <Col span={12}>
                <Form.Item label="Order Cooldown Seconds">
                  <InputNumber
                    min={0}
                    precision={0}
                    value={editingData?.OrderCooldownSeconds}
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      setEditingData({
                        ...editingData,
                        OrderCooldownSeconds: Math.max(0, parseInt(value, 10) || 0),
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Per Person Limit">
                  <InputNumber
                    min={0}
                    precision={0}
                    value={editingData?.PerPersonLimit}
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      setEditingData({
                        ...editingData,
                        PerPersonLimit: Math.max(0, parseInt(value, 10) || 0),
                      })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            {selectedItemDetails.length > 0 && (
              <Form.Item>
                <Checkbox
                  checked={editingData?.SpellInstruction}
                  onChange={(e) =>
                    setEditingData({
                      ...editingData,
                      SpellInstruction: e.target.checked,
                    })
                  }
                >
                  Spell Instruction
                </Checkbox>
              </Form.Item>
            )}
            <Divider />
            {/* Available Time Period in Modal */}
            <Form.Item label="Available Time Period">
              <div style={{ display: 'flex', gap: '8px' }}>
                <Form.Item name="MenuItemStartTime" style={{ margin: 0, flex: 1 }}>
                  <TimePicker
                    placeholder="Start Time"
                    format="HH:mm"
                    value={editingData?.MenuItemStartTime}
                    onChange={(time) => {
                      setEditingData({
                        ...editingData,
                        MenuItemStartTime: time,
                      });
                      // Optionally reset EndTime if StartTime changes
                      if (
                        editingData.MenuItemEndTime &&
                        time &&
                        time.isAfter(editingData.EndTime)
                      ) {
                        setEditingData({
                          ...editingData,
                          MenuItemStartTime: time,
                          MenuItemEndTime: null,
                        });
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item name="MenuItemEndTime" style={{ margin: 0, flex: 1 }}>
                  <TimePicker
                    placeholder="End Time"
                    format="HH:mm"
                    value={editingData?.MenuItemEndTime}
                    disabled={!editingData?.MenuItemStartTime}
                    disabledTime={() => getDisabledEndTime(editingData?.MenuItemStartTime)}
                    onChange={(time) =>
                      setEditingData({
                        ...editingData,
                        MenuItemEndTime: time,
                      })
                    }
                  />
                </Form.Item>
              </div>
            </Form.Item>
          </Form>
          <Divider />
          {/* Submenus in Modal */}
          {selectedItemDetails.map((detail, index) => (
            <Card
              key={index}
              title={`Menu Link Title ${index + 1}`}
              style={{ marginBottom: 16 }}
            >
              {/* Submenu Editing */}
              <Form.Item label="Description 1">
                <Input
                  value={detail.Description1}
                  onChange={(e) =>
                    updateSubMenuData(index, 'Description1', e.target.value)
                  }
                />
              </Form.Item>
              <Form.Item label="Description 2">
                <Input
                  value={detail.Description2}
                  onChange={(e) =>
                    updateSubMenuData(index, 'Description2', e.target.value)
                  }
                />
              </Form.Item>
              <Form.Item label="Number Of Choice">
                <InputNumber
                  value={detail.NumberOfChoice}
                  onChange={(value) =>
                    updateSubMenuData(index, 'NumberOfChoice', value)
                  }
                />
              </Form.Item>
              {/* Child Submenus */}
              {detail.childSubMenus.map((child, childIndex) => (
                <div key={childIndex}>
                  <Divider orientation="left">
                    Child SubMenu {childIndex + 1}
                  </Divider>
                  <Form.Item label="Description 1">
                    <Input
                      value={child.Description1}
                      onChange={(e) =>
                        updateChildSubMenuData(
                          index,
                          childIndex,
                          'Description1',
                          e.target.value
                        )
                      }
                    />
                  </Form.Item>
                  <Form.Item label="Description 2">
                    <Input
                      value={child.Description2}
                      onChange={(e) =>
                        updateChildSubMenuData(
                          index,
                          childIndex,
                          'Description2',
                          e.target.value
                        )
                      }
                    />
                  </Form.Item>
                  <Form.Item label="Sales Price">
                    <InputNumber
                      value={child.SalesPrice}
                      onChange={(value) =>
                        updateChildSubMenuData(
                          index,
                          childIndex,
                          'SalesPrice',
                          value
                        )
                      }
                    />
                  </Form.Item>
                </div>
              ))}
            </Card>
          ))}
        </div>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        title="Confirmation"
        open={isConfirmModalVisible}
        onOk={handleConfirmModalOk}
        onCancel={handleConfirmModalCancel}
      >
        <p>This change will affect the following menu items:</p>
        <ul>
          {matchedMainItems.map((description, index) => (
            <li key={index}>{description}</li>
          ))}
        </ul>
      </Modal>

      {/* Image Management Modal */}
      <Modal
        title={`Manage Image - ${currentImageItem?.Description1 || 'Menu Item'}`}
        open={isImageModalVisible}
        onCancel={handleImageModalClose}
        footer={null}
        width={600}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
          {/* Image Preview */}
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            {itemImagePreview ? (
              <img
                crossOrigin="anonymous"
                src={itemImagePreview}
                onError={(e) => { 
                  e.target.onerror = null; 
                  e.target.src = '/img/blank.jpeg';
                }}
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '400px', 
                  objectFit: 'contain', 
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9'
                }}
                alt="Item preview"
              />
            ) : (
              <div style={{ 
                width: '300px', 
                height: '300px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                border: '2px dashed #d9d9d9',
                borderRadius: '8px',
                color: '#999'
              }}>
                No Image
              </div>
            )}
          </div>

          {/* Action Buttons */}
          {!isEditingImage ? (
            <div style={{ display: 'flex', gap: '12px', width: '100%', justifyContent: 'center' }}>
              <Button 
                type="primary" 
                icon={<UploadOutlined />}
                onClick={handleStartEditImage}
                size="large"
              >
                Edit
              </Button>
              {itemImagePreview && itemImagePreview !== '/img/blank.jpeg' && (
                <Button 
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    Modal.confirm({
                      title: 'Delete Image',
                      content: 'Are you sure you want to delete this image?',
                      okText: 'Yes',
                      okType: 'danger',
                      cancelText: 'No',
                      onOk: handleDeleteImageFromServer,
                    });
                  }}
                  size="large"
                >
                  Delete
                </Button>
              )}
            </div>
          ) : (
            <div style={{ width: '100%' }}>
              {/* Upload Section */}
              <div style={{ marginBottom: '16px' }}>
                <Upload
                  accept="image/*"
                  beforeUpload={handleImageUpload}
                  showUploadList={false}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />} block size="large">
                    {itemImageFile ? 'Change Image' : 'Upload Image / Take Photo'}
                  </Button>
                </Upload>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '8px', textAlign: 'center' }}>
                  Image will be automatically compressed to under 200KB
                  <br />
                  Recommended size: 800x800px
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <Button 
                  type="primary"
                  onClick={handleSaveImage}
                  disabled={!itemImageFile}
                  size="large"
                >
                  Save
                </Button>
                <Button 
                  onClick={handleCancelEditImage}
                  size="large"
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </Form>
  );
};

export default MenuListComponent;
